// Ourteam2.js

import React from 'react';


function Ourteam2() {
  // Define team members as an array of objects
  const teamMembers = [
    {
      imgSrc: '/1.png',
      name: 'Al fiqie',
      role: 'Chief Executive Officer',
    },
    {
      imgSrc: '/2.png',
      name: 'Rizvan Adrian Kurniawan',
      role: 'Chief Marketing Officer',
    },
    {
      imgSrc: '/3.png',
      name: 'Nur Rohman',
      role: 'Chief Technology Officer',
    },
    {
      imgSrc: '/4.png',
      name: 'Siril Fuad',
      role: 'Secretary and Chief Financial Officer',
    },
    {
      imgSrc: '/5.png',
      name: 'Muhammad Syihabuddin Balya',
      role: 'Business development',
    },
  ];

  return (
    <div id='team' className="container my-10 mx-auto md:px-6">
      <section className="mb-20 text-center font-EBGaramond">
        <h2 className="mb-12 text-3xl font-bold">
          Our Teams
        </h2>

        <div className="lg:gap-xl-12 grid gap-x-6 max-lg:grid-cols-3 max-sm:grid-cols-2 lg:grid-cols-5 max-sm:mx-3 ">
          {teamMembers.map((member, index) => (
            <div key={index} className="mx-auto justify-center items-center  ">
              <img
                className="mx-auto mb-2 rounded-lg  dark:shadow-black/20 w-[200px] shadow-2xl hover:shadow-custom "
                src={member.imgSrc}
                alt="avatar"
              />
              <h5 className="text-lg font-bold max-sm:text-sm">{member.name}</h5>
              <p className="mb-2">{member.role}</p>
              <ul className="mx-auto flex list-inside justify-center">
                {/* Add social links here */}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Ourteam2;
